import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_CHATBOT_CONTENT } from './api/graphql/queries';
import CtaContentImageBlock from '../components/organisms/ctaContentImageBlock/CtaContentImageBlock';
import IconCopyCardListBlock from '../components/organisms/iconCopyCardListBlock/IconCopyCardListBlock';
import IconCardListBlock from '../components/organisms/iconCardListBlock/IconCardListBlock';
import CtaOneColumnBlock from '../components/organisms/ctaOneColumnBlock/CtaOneColumnBlock';
import TwoColumnImageWebForm from '../components/sections/twoColumnImageWebForm/TwoColumnImageWebForm';

/**
 * Ayoba Web Chatbot Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ChatbotPage = (props) => {
    /**
     * Section content
     */
    const { chatbot } = props?.data;
    const { page_header, what_sets_us_apart, use_cases, subfooter } = chatbot?.data?.attributes;
    const { feedback } = props?.data.partner.data.attributes;

    return (
        <div className={`${classes.oChatbotPage} ${classes.oPage}`}>
            <CtaContentImageBlock {...page_header} />
            <IconCopyCardListBlock {...what_sets_us_apart} />
            <IconCardListBlock {...use_cases} />
            <TwoColumnImageWebForm {...feedback} type="Chatbot" />
            <CtaOneColumnBlock {...subfooter} />
        </div>
    );
};

export async function getServerSideProps() {
    // const locale = context.query?.lang || context.defaultLocale;

    const { data } = await client.query({
        query: GET_CHATBOT_CONTENT,
        variables: { _locale: 'en' }
    });

    return {
        props: { data }
    };
}

export default ChatbotPage;
